<div class="dialog-box">
  <div class="mat-dialog-title" mat-dialog-title>
      <div id="lblHeading">
          File Upload Wizard
          <i class="fa fa-times-circle pull-right" style="padding-left: 10px;" (click)="togglePopupDialog()" aria-hidden="true"></i>
          <i class="fa pull-right" [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}" (click)="toggleFullscreen()"></i>
          <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
          <!-- <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i> -->
      </div>
  </div>
</div>
<div mat-dialog-content>
  <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
      <div class="eip-px-20 eip-pb-20">

          <div class="k-grid-toolbar-content d-flex" style="justify-content: end;" *ngIf="enableFullscreen">
              <div class="icons-container">
                  <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                      <div class="icon-wrap" (click)="toggleFullscreen()">
                          <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                          <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                          <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i>
                      </div>
                  </div>
              </div>
          </div>
          <div class="container" appDragAndDrop (fileDropped)="onFileDropped($event)">
              <i class="fa fa-upload fs-30" aria-hidden="true"></i>
              <input type="file" #file accept="{{fileAccepts}}" placeholder="Choose file" (change)="file_onChange(file.files, true)" style="display:none;" multiple>
              <p class="fs-20">Drag and drop file(s) here</p>
              <p class="fs-20">or</p>
              <label for="fileDropRef" class="file-upload" (click)="file.click()">Browse local file(s)</label>
              <div class="notification">★&nbsp;File size more than 100MB, will consider as large file.</div>
          </div>
          <div class="file-display" *ngIf="fileCollection.length > 0" style="max-height: 100%;">
              <kendo-grid #fileDisplayGrid [kendoGridBinding]="fileCollection" [reorderable]="false" [sortable]="false" [resizable]="true" [pageable]="false" style="width: 100%; margin-left: 0px !important; margin-right: 0px !important;">
                  <kendo-grid-column title="Document/Message" field="selecteDocument" width="240" [headerStyle]="{'text-align': 'left'}">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <EIPAutoComplete ShowTextValueField='N' [formControlName]="index" WaterMarkText="Select Document/Message" [defaultValue]="selecteDocument[rowIndex]" ValueField="value" TextField="text" [dataSource]='documentList' [IsDisabled]="!isDocumentListDisabled" [IsCascading]='false' (valueChange)='onChange_Document($event, rowIndex, dataItem)'>
                          </EIPAutoComplete>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="File Name" field="displayFileName" width="130" [headerStyle]="{'text-align': 'left'}">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 p-0" style="font-weight: bold; margin-top:9px;" title="{{dataItem.fileName}}">
                              <span *ngIf="!enableFullscreen" class="eip-pl-10 eip-pr-10">{{dataItem.displayFileName}}</span>
                              <span *ngIf="enableFullscreen" class="eip-pl-10 eip-pr-10">{{dataItem.fileName}}</span>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="File Size" field="fileSize" width="100" [headerStyle]="{'text-align': 'left'}">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 p-0" style="font-weight: bold; margin-top:9px;">
                              <span class="eip-pl-10 eip-pr-10">{{formatSizeUnits(dataItem.fileSize)}}</span>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="File Type" field="selecteFileType" width="120" [headerStyle]="{'text-align': 'left'}">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <EIPAutoComplete ShowTextValueField='N' [formControlName]="index" WaterMarkText="Select File Type" [defaultValue]="dataItem.fileType" ValueField="dedId" TextField="dedDescription" [dataSource]='fileTypeList' [IsCascading]='false' [IsDisabled]="(dataItem.progress == 100)" (valueChange)='onChange_FileType($event, rowIndex, dataItem)'>
                          </EIPAutoComplete>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Upload Status" field="status" width="130" [headerStyle]="{'text-align': 'left'}">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div class="progress">
                              <div role="progressbar" class="progress-bar progress-bar-striped" [ngClass]="(dataItem.status == 'Failed') ? 'bg-danger' : 'bg-success'" [ngStyle]="{'width':dataItem.progress+'%'}">
                              </div>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Action" field="fileIndex" width="100" [headerStyle]="{'text-align': 'left'}">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <button type="button" class="fa fa-upload btn-upload btn btn-success" (click)="upload(dataItem.fileIndex)" [disabled]="(dataItem.progress == 100) || isfileUpload"></button>
                          <button type="button" class="fa fa-remove btn-upload btn btn-danger eip-ml-5" (click)="deleteFile(dataItem.fileIndex)" [disabled]="(dataItem.progress == 100)"></button>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>

              <!-- <div class="row m-0 uploadList" *ngFor="let item of fileCollection">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 p-0" style="font-weight: bold; margin-top:9px;"
        title="{{item.fileName}}">
        <span class="eip-pl-10 eip-pr-10">{{item.displayFileName}}
          ({{formatSizeUnits(item.fileSize)}})</span></div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 p-0" style="margin-top: 10px;">
        <div class="progress">
          <div role="progressbar" class="progress-bar progress-bar-striped"
            [ngClass]="(item.status == 'Failed') ? 'bg-danger' : 'bg-success'"
            [ngStyle]="{'width':item.progress+'%'}">
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 p-0" style="margin-top: 5px;">
        <div class="eip-pl-10 eip-pr-10 text-right">
          <button type="button" class="fa fa-upload btn btn-success" (click)="upload(item.fileIndex)"
            [disabled]="(item.progress == 100)"></button>
          <button type="button" style="margin-left: 5%; " class="fa fa-remove btn btn-danger"
            (click)="deleteFile(item.fileIndex)" [disabled]="(item.progress == 100)"></button></div>
      </div>
    </div> -->
    
          </div>
          <div class="row m-0">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center eip-mt-15">
                  <button type="button" class="btn btn-primary" (click)="uploadAll()" [disabled]="isDisabled()"><i class="fa fa-upload" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Upload
                      All</button>
              </div>
          </div>
      </div>
  </div>
</div>